import { __, __x, __nx, __N } from 'JIX/gettext.js';

export function remainingText (minLength, maxLength, currentLength) {
    let needed = minLength - currentLength;
    let count  = maxLength - currentLength;

    if (needed > 0) {
        return { text: __x('Du mangler {needed} tegn.', { needed }), danger: true };
    } else if (count >= 0) {
        return { text: __nx('Du har {count} tegn tilbage.', 'Du har {count} tegn tilbage.', count, { count }), danger:  false };
    } else {
        return { text: __nx('Du har brugt {count} tegn for meget.', 'Du har brugt {count} tegn for meget.', -count, { count: -count }), danger: true };
    }
}

//Watches an input field by ID and automatically updates the text in another element with the result of calling remainingText
//Arguments:
//  minLength: The minimum length of input expected
//  maxLength: The maximum length of input expected
//  counterElementTextFunction: Function that takes the output of remainingText and displays it
//  registerEventFunction: Function that registers an appropriate event listener. Takes one argument, f, that is the function to call when the event fires.
//  getLengthFunction: function that returns as an integer the length of the input we are watching
function remainingTextSetUpListener(minLength, maxLength, counterElementTextFunction, registerEventFunction, getLengthFunction) {
    counterElementTextFunction(remainingText(minLength, maxLength, getLengthFunction()));
    registerEventFunction(function () {
        counterElementTextFunction(remainingText(minLength, maxLength, getLengthFunction()));
    });
}

// Sets up a listener on a given input element that updates the textContent of
// a counterElement with the output of remainingText every time the input
// changes
// Arguments:
//  minLength, maxLength: The bounds of the input length.
//  inputSelector: The DOM Element for the input field we want to listen to
//  counterElementSelector: The DOM Element for the element that will
export function remainingTextInputField(minLength, maxLength, inputElement, counterElement) {
    remainingTextSetUpListener(
        minLength,
        maxLength,
        (h) => _update_counter_element(counterElement, h),
        (f) => inputElement.addEventListener('input', f),
        ()  => inputElement.value.length
    );
}

function _update_counter_element(counterElement, h) {
    counterElement.textContent = h.text;
    if (h.danger) {
        counterElement.classList.remove("text-muted");
        counterElement.classList.add("text-danger");
    } else {
        counterElement.classList.remove("text-danger");
        counterElement.classList.add("text-muted");
    }
}

// Sets up a listener on a given codemirror element that updates the
// textContent of a counterElement with the output of remainingText every time
// the input changes.
// Arguments:
//  minLength, maxLength: The bounds of the input length.
//  inputSelector: The DOM Element for the codemirror editor we want to listen to
//  counterElementSelector: The DOM Element for the element that will
export function remainingTextCodeMirror(minLength, maxLength, codemirrorInstance, counterElement) {
    remainingTextSetUpListener(
        minLength,
        maxLength,
        (h) => _update_counter_element(counterElement, h),
        (f) => codemirrorInstance.CodeMirror.on('changes', f),
        ()  => codemirrorInstance.CodeMirror.getValue().length
    );
}
